module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"next":"Наступне зображення (→)","prev":"Попереднє зображення (←)"},"en":{"next":"Next image (→)","prev":"Previous image (←)"}}')
  delete Component.options._Ctor
}
